<template>
    <div class="fullWidth">
        <kgr-generic-select
            v-model="selection"
            :options="options"
            display="name"
            :disabled="disabled"
            :no-null-option="!allowNullOption"
            @post-input="updateLevel()"
        />
    </div>
</template>

<script>
import GenericSelect from './GenericSelect.vue'

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        value: {
            type: Number,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowNullOption: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            options: [
                {value: 1, name: this.$t('trainerLicenses.level.1')},
                {value: 2, name: this.$t('trainerLicenses.level.2')},
                {value: 3, name: this.$t('trainerLicenses.level.3')},
                {value: 4, name: this.$t('trainerLicenses.level.4')},
            ],
            selectionValue: null,
        }
    },
    computed: {
        selection: {
            get() {
                if (this.value === null && this.selectionValue === null) {
                    return null;
                } else {
                    if (this.selectionValue === null) {
                        return this.options.find(element => element.value === this.value)
                    } else {
                        return this.options.find(element => element.value === this.selectionValue)
                    }
                }
            },
            set(object) {
                this.selectionValue = object !== null ? object.value : null;
            }
        }
    },
    methods: {
        updateLevel() {
            this.$emit('input', this.selectionValue);
            this.$nextTick(() => {
                this.$emit('post-input', this.selectionValue);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .fullWidth {
        width: 100%;
    }
</style>
